import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = [
    'accordionHeader',
    'accordionContent',
    'accordionWrapper',
    'filterValues',
    'input',
  ];

  static classes = ['selected'];

  static values = {
    modalIdentifier: String,
  };

  connect() {
    this.closeAllAccordions();
    this.accordionHeaderTargets.forEach((header) => {
      header.addEventListener('click', this.toggleAccordion.bind(this));
    });

    this.updateAllWrapperClasses();
  }

  toggleAccordion = (event) => {
    const content = event.currentTarget.nextElementSibling;
    const open = JSON.parse(content.dataset.visible);
    const openIcon = event.currentTarget.querySelector('svg[data-icon="openIcon"]');

    if (open) {
      openIcon.classList.remove('rotate-180');
    } else {
      openIcon.classList.add('rotate-180');
    }

    this.closeAllAccordions();

    content.dataset.visible = !open;
  };

  updateWrapperClasses = (event) => {
    const checkbox = event.target;
    const wrapper = this.accordionWrapperTargets.find((w) => w.contains(checkbox));

    if (wrapper) {
      this.toggleWrapperClasses(wrapper);
    }
  };

  updateAllWrapperClasses = () => {
    this.accordionWrapperTargets.forEach((wrapper) => {
      this.toggleWrapperClasses(wrapper);
    });
  };

  toggleWrapperClasses = (wrapper) => {
    const hasCheckedBoxes = wrapper.querySelectorAll('input[type="checkbox"]:checked').length > 0;

    if (hasCheckedBoxes) {
      wrapper.classList.add(...this.selectedClasses);
    } else {
      wrapper.classList.remove(...this.selectedClasses);
    }
  };

  closeAllAccordions = () => {
    this.accordionContentTargets.forEach((content) => {
      if (content.dataset.visible === 'true') {
        content.parentElement.querySelector('button > svg')?.classList.remove('rotate-180');
      }
      content.dataset.visible = false;
    });
  };

  apply() {
    const url = new URL(window.location.href);

    this.inputTargets.forEach((checkbox) => url.searchParams.delete(checkbox.name));
    this.inputTargets.forEach((checkbox) => {
      if (checkbox.checked) url.searchParams.append(checkbox.name, checkbox.value);
    });

    this.closeModal();

    Turbo.visit(url);
  }

  closeModal() {
    const modal = document.querySelector(`[data-controller="${this.modalIdentifierValue}"]`);
    if (modal) {
      modal.close();
      modal.remove();
    }
  }

  clearFilters(event) {
    const listbox = event.currentTarget.closest('[role="listbox"]');
    if (listbox) {
      listbox.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      this.updateAllWrapperClasses();
    }
  }
}
